var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        height: "100%",
        display: "flex",
        "flex-direction": "column"
      },
      attrs: { id: "tabLclUnitLoadDevice" }
    },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "app-main-inner",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c("template", { slot: "up" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.readonly && _vm.viewSource !== "salesDetail",
                    expression: "readonly && viewSource!=='salesDetail'"
                  }
                ],
                staticClass: "section"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "1", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.addSlaveHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "2", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.pm.removeSlaveHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section", staticStyle: { "flex-grow": "1" } },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    no: "3",
                    "grid-options": _vm.gridOptions,
                    "grid-params": _vm.gridParams,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.lclSlaves
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c("div", { staticStyle: { padding: "5px 0" } }, [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      staticStyle: { color: "green" },
                      attrs: { no: "4", type: "info", plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.pm.addToUnitLoadDeviceHandler()
                        }
                      }
                    },
                    [_vm._v("↓")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      staticStyle: { color: "red" },
                      attrs: { no: "5", type: "info", plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.pm.removeToUnitLoadDeviceHandler()
                        }
                      }
                    },
                    [_vm._v("↑")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "55px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.totalLabel.package }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.slaveTotalDesc.slaveTotalQuantity)
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.TotalNumberOfPackages")
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.slaveTotalDesc.slaveTotalWeight))
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.TotalCubage") }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.slaveTotalDesc.slaveTotalCubage))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "template",
            { slot: "down" },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { height: "100%", "min-height": "300px" },
                  attrs: {
                    "left-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "20%"
                    },
                    "right-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "80%"
                    }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "left" },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          no: "6",
                          "grid-options": _vm.left.gridOptions,
                          "grid-params": _vm.left.gridParams,
                          "column-defs": _vm.unitLoadDeviceColumnDefs,
                          "row-data": _vm.unitLoadDevices
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(_vm.left, "gridParams", $event)
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(_vm.left, "gridParams", $event)
                          },
                          gridReady: function(params) {
                            return (_vm.left.gridApi = params.api)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            no: "7",
                            "grid-options": _vm.right.gridOptions,
                            "grid-params": _vm.right.gridParams,
                            "column-defs": _vm.usageColumnDefs,
                            "row-data":
                              _vm.selectedUnitLoadDevice.unitLoadDeviceUsage
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.right, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.right, "gridParams", $event)
                            },
                            gridReady: function(params) {
                              return (_vm.right.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { padding: "5px 0" } }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.usagesTotalDesc.txtNum))])
                      ]),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": "55px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.package }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.usagesTotalDesc.usageTotalQuantity
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.weight }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.usagesTotalDesc.usageTotalWeight
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.cubage }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.usagesTotalDesc.usageTotalCubage
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _c("query-ae-lcl-dialog", {
        attrs: { visible: _vm.queryAeLclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryAeLclDialog, "visible", $event)
          },
          attachSubJobCallBackHandler: function(rows) {
            _vm.pm.slaveAddedHandler(rows)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }